"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeSearchForm = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../hooks/useForm");
const reservation_1 = require("../../../utils/reservation");
const Button_1 = require("../../Button");
const Number_1 = require("../../Form/Field/Number");
const Select_1 = require("../../Form/Field/Select");
const OneWayDateEditor_1 = require("./components/OneWayDateEditor");
const OneWaySwitcher_1 = require("./components/OneWaySwitcher");
const ReturnWayDateEditor_1 = require("./components/ReturnWayDateEditor");
require("./index.scss");
const className = 'front-search-form';
const descriptor = {
    airportFrom: useForm_1.allDescriptors.object({
        restrictions: {
            required: true,
        },
    }),
    airportTo: useForm_1.allDescriptors.object({
        restrictions: {
            required: true,
        },
    }),
    adult: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            integer: true,
            required: true,
        },
    }),
    child: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            integer: true,
            required: true,
        },
    }),
    infant: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
        },
        validateByValues: (values) => {
            if (values.adult === undefined || values.infant === undefined)
                return;
            if (values.infant <= values.adult)
                return;
            return [reservation_1.reservationValidationText.tooManyInfants];
        },
    }),
    isOneWay: useForm_1.allDescriptors.boolean(),
    departureDate: useForm_1.allDescriptors.string({
        restrictions: {
            required: true,
        },
    }),
    returnDate: useForm_1.allDescriptors.string(),
};
const HomeSearchForm = (props) => {
    const { config, propsValues, onChange, submit, validateForm } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const { fields, isValid, validateAll, values, } = (0, useForm_1.useForm)({
        descriptor, config, propsValues, onChange, validateForm,
    });
    const onSubmit = () => {
        if (!validateAll(values))
            return;
        submit(values);
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(Select_1.FormFieldSelect, { value: fields.airportFrom.value, setValue: fields.airportFrom.onValue, toItem: (x) => ({
                            label: (x.name)[locale],
                            value: x.code,
                        }), name: 'FromAirport', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/From:label', defaultMessage: 'From' }), placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/From:placeholder', defaultMessage: 'select...' }), items: fields.airportFrom.items, modificators: fields.airportFrom.modifiers, error: fields.airportFrom.error }))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(Select_1.FormFieldSelect, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/To:label', defaultMessage: 'To' }), placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/To:placeholder', defaultMessage: 'select...' }), items: fields.airportTo.items, error: fields.airportTo.error, modificators: fields.airportTo.modifiers, setValue: fields.airportTo.onValue, value: fields.airportTo.value, toItem: (x) => ({
                            label: (x.name)[locale],
                            value: x.code,
                        }) }))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(Number_1.FormFieldNumber, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/Adults:label', defaultMessage: 'Adults (12y+)' }), value: fields.adult.value, setValue: fields.adult.onValue, modificators: fields.adult.modifiers, error: fields.adult.error })),
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(Number_1.FormFieldNumber, { value: fields.child.value, setValue: fields.child.onValue, modificators: fields.child.modifiers, error: fields.child.error, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/Children:label', defaultMessage: 'Children (2-12y)' }) })),
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(Number_1.FormFieldNumber, { value: fields.infant.value, setValue: fields.infant.onValue, modificators: fields.infant.modifiers, error: fields.infant.error, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/Infants:label', defaultMessage: 'Infants (<2y)' }) }))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement(OneWaySwitcher_1.OneWaySwitcher, { field: fields.isOneWay }))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` }, fields.isOneWay.value
                    ? (react_1.default.createElement(OneWayDateEditor_1.OneWayDateEditor, { departing: fields.departureDate }))
                    : (react_1.default.createElement(ReturnWayDateEditor_1.ReturnWayDateEditor, { departing: fields.departureDate, returning: fields.returnDate })))),
            react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/Submit:text', defaultMessage: 'Search flights' }), modificators: ['block', 'primary'], onClick: onSubmit, disabled: !isValid })))));
};
exports.HomeSearchForm = HomeSearchForm;
//# sourceMappingURL=index.js.map